import { createClient } from '@supabase/supabase-js'
import { router } from "vue-router"
const supabaseAnonKey = "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJyb2xlIjoiYW5vbiIsImlhdCI6MTYyOTczODEzMywiZXhwIjoxOTQ1MzE0MTMzfQ.bbTgJiqHtaxL7lXTqKCeMvSsUanOcuZXTaPIYICg1wo"

//sbp_dfaa2ffd17d2ad6d225876f578de07ec7dc7a65f
const supabaseUrl = "https://skhqwapgnjfosegxxknz.supabase.co";
export const supabase = createClient(supabaseUrl, supabaseAnonKey)
console.log("db object", supabase)
